import { DynamicGalleryEnvService } from '@aipb/gulliver/dynamic-gallery/env';
import {
  Castor,
  Collection,
  CollectionContent,
  DynamicGalleryBaseResponse,
  Navigation,
  RecordContent,
  RequestDataModel,
  SearchParams,
  SearchResponse
} from '@aipb/gulliver/dynamic-gallery/model';
import { AuthService } from '@aipb/shared/auth';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { captureException } from '@sentry/browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DynamicGalleryApiService {
  constructor(
    private http: HttpClient,
    private dynamicGalleryEnv: DynamicGalleryEnvService,
    private auth: AuthService
  ) {}

  public requestData(url: string): Observable<RequestDataModel> {
    let httpParams = new HttpParams();

    httpParams = httpParams.set('jwt', this.auth.token);

    return this.http
      .get<
        DynamicGalleryBaseResponse<{
          collection: Collection;
          navigation: Navigation;
          castor: Castor;
        }>
      >(url, {
        params: httpParams
      })
      .pipe(
        map((data) => {
          if (data.error.code != 0) {
            captureException(data.error.msg);
            return {
              navigation: {
                breadcrumbs: [],
                pagination: {
                  links: [],
                  recordsCount: 0,
                  pageSize: 0,
                  pagesCount: 0,
                  pageNum: 0
                }
              },
              collection: {
                url: '',
                contents: [],
                label: '',
                description: ''
              },
              collections: [],
              records: [],
              castor: {
                url: '',
                coreId: '',
                uniqueIdName: ''
              }
            };
          }

          return {
            navigation: data.result.navigation,
            collection: data.result.collection,
            collections: data.result.collection.contents
              ? data.result.collection.contents.filter((c) => c.type === 'collection').map((c) => <CollectionContent>c)
              : [],
            records: data.result.collection.contents
              ? data.result.collection.contents.filter((c) => c.type === 'record').map((c) => <RecordContent>c)
              : [],
            castor: data.result.castor
          };
        })
      );
  }

  search(params: SearchParams): Observable<SearchResponse> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('request', 'search');
    httpParams = httpParams.set('jwt', this.auth.token);

    for (const key of Object.keys(params)) {
      if (!params[key]) continue;

      httpParams = httpParams.set(key, params[key]);
    }

    return this.http
      .get<DynamicGalleryBaseResponse<SearchResponse>>(this.dynamicGalleryEnv.env.apiUrl, {
        params: httpParams
      })
      .pipe(map((data) => data.result));
  }
}
